import "../../../core/src/assets/css/body.css";

import {
    AuthenticatedRoute,
    RelodeApp,
    RelodeAppConfig,
    siteTheme,
} from "@relode/core";
import * as React from "react";
import { Route, Switch } from "react-router-dom";

import { App } from "./features/app/app";
import { PublicApp } from "./features/app/publicApp";
import {
    jobPositions,
    locations,
    normalizedJobTitles,
    tags,
} from "./shared/backend/controllers";
import { messageTitleFactory } from "./shared/messageTitleFactory";

const config: RelodeAppConfig = {
    appName: "client",
    version: "v2",
    locationLookupService: locations.locationLookupService,
    jobPositionLookupService: jobPositions.jobPositionLookupService,
    normalizedJobTitleLookupService:
        normalizedJobTitles.normalizedJobTitleLookupService,
    tagsLookupService: tags.tagsLookupService,
    messageTitleFactory,
};

export const Root = () => (
    <RelodeApp config={config} theme={siteTheme}>
        <Switch>
            <Route path="/public" component={PublicApp} />
            <AuthenticatedRoute component={App} appName={config.appName} />
        </Switch>
    </RelodeApp>
);
